import React, {useEffect, useState} from 'react';
import SubmitInquiry from './SubmitInquiry';
import Footer from '../Footer';
import { getCookie } from '../../helpers/CookieHandler';
import { api } from '../index.api';
import { triggerSSO } from '../InitiateSSO';

const SubmitInquiryPage = (props) => {

    const [messageItems, setMessageItems] = useState([]);

    useEffect(() => {
        loadSiteMessages();
      }, []);
      const loadSiteMessages = () => {
       const userLanguage = getCookie("welcomeLanguage");
       const userCountry = getCookie("welcomeCountryCode");
    
        api.siteMessages(
          {
            languageCode: userLanguage,
            countryCode: userCountry
          },
          _loadSiteMessagesSuccessHandler,
          _loadSiteMessagesFailureHandler
        );
      };
    
      const _loadSiteMessagesSuccessHandler = (response) => {
        if (response.status === 200) {
          response.json().then(responseJson => {
            setMessageItems(responseJson);
          });
        } else if (response.status === 401) {
          _showNotification(
            'Error',
            'You are not authorized to perform this action. Please log in again.',
            'error'
          );
          setTimeout(() => triggerSSO(props.pageContent.content.lang), 3000);
        } else {
          _showNotification(
            'Error',
            'Error occurred while submitting query to get site messages for home page',
            'error'
          );
        }
      };
    
      const _loadSiteMessagesFailureHandler = (error) => {
        _showNotification('Error', 'Unexpected error occurred!!', 'error');
      };
    
      const _showNotification = (title, message, type) => {
        alert(`${type}: ${title}: ${message}`);
      };
    
    return (
    <div className='page-container'>
        <div className='page-content'>
            <SubmitInquiry embedded='false' flowType='MI_PORTAL_REQUEST' messageItems={messageItems} {...props} />
        </div>
        <Footer submitInquiry={false} />
    </div>)
}

export default SubmitInquiryPage


// WEBPACK FOOTER //
// ./src/mi-app/submitInquiry/SubmitInquiryPage.js